const KeyMirror = require("keymirror");

// Export types
module.exports = KeyMirror({
    SNACKBAR_MESSAGE: true,
    SNACKBAR_HIDE: true
});



// WEBPACK FOOTER //
// ./src/action-types/snackbar.js